module.exports = __webpack_public_path__ + "assets/img/btn-view-b9bd5e65.png";